const whyChooseUsItems = [
    {
        id: 1,
        title: 'Planning',
        description: "Premium homes and builds for smart buyers in East Tambaram and Chennai—expert planning, local approvals guidance, and construction that holds long-term value.",
        backgroundImage: './assets/images/choose-card-img1.jpg',
        logo: './assets/icons/house-door.svg'
    },
    {
        id: 2,
        title: 'Approval',
        description: 'Architectural planning and approvals support for Tamil Nadu projects—from East Tambaram to wider Chennai—with clear drawings and contractor-ready documentation.',
        backgroundImage: './assets/images/choose-card-img2.jpg',
        logo: './assets/icons/cart2.svg'
    },
    {
        id: 3,
        title: 'Construction',
        description: "On-site construction for residential and commercial clients in Chennai: skilled crews, quality materials, and engineering discipline—trusted builders from Tambaram to the city core.",
        backgroundImage: './assets/images/choose-card-img3.jpg',
        logo: './assets/icons/cash.svg'
    }
];

export default whyChooseUsItems;